const interfaceTranslations = {
  selectedCountryAriaLabel: "کشور انتخاب شده",
  noCountrySelected: "هیچ کشوری انتخاب نشده است",
  countryListAriaLabel: "لیست کشورها",
  searchPlaceholder: "جستجو",
  zeroSearchResults: "هیچ نتیجه‌ای یافت نشد",
  oneSearchResult: "1 نتیجه یافت شد",
  multipleSearchResults: "${count} نتیجه یافت شد",
  // additional countries (not supported by country-list library)
  ac: "جزیره اسنشن",
  xk: "کوزوو"
};
export default interfaceTranslations;
